import React, { useEffect, useRef, useState } from "react";
import "./MindMap.scss";
import "@Src/features/Filter/Filter.scss";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { Paginator } from "primereact/paginator";
import { Skeleton } from "primereact/skeleton";
import { Tooltip } from "react-tooltip";
import { useFormik } from "formik";
import { useAppSelector } from "@App/hooks";
import { useSubscriptionAccess } from '@Src/hooks/useSubscriptionAccess';
import { isInstituteStudent } from '@Src/utils/studentTypeUtils';
import { FILTER_KEYS, FILTER_LIST } from "@Src/features/Filter/Constants/filters.constants";
import {
    getSubjectList,
    getLanguageList,
} from "@Src/features/UserProfile/Services/UserProfile.sevice";
import {
    getChapterList,
    getTopicList,
} from "@Src/features/TestDetails/services/TestDetails.service";
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";
import { getCombinedClassList } from "@Src/features/Auth/components/exam_prefrences/services/examPrefrences.service";
import { getMindMapFile, getMindMapList, postNoteAndBookmark } from "./services/MindMap.service";
import { Dialog } from "primereact/dialog";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { TestSereisRouteURL } from "@Constants/app-route-url.constant";

import { ProgressSpinner } from 'primereact/progressspinner';

import SvgIcon from "@Components/icons/SvgIcon";

interface MindMapItem {
    id: number;
    ClassId: number;
    BoardId: number;
    SubjectId: number;
    ChapterId: number;
    TopicId: number;
    LangId: number;
    subjectName: string;
    chapterName: string;
    topicName: string;
    boardName: string;
    className: string;
    langaugeName: string;
    revisionnotedocUrl: string | null;
    mindmapdocUrl: string | null;
    formulaDocFileUrl: string | null;
    lastMinuteDocFileUrl: string | null;
    Note: string | null;
    IsBookMarked: number | null;
}

export const MindMapIndex = () => {
    const coursePreferences = useAppSelector((state: any) => state.coursePreferences);
    const loginData = useAppSelector((state: any) => state.login);
    const isInstitute: boolean = isInstituteStudent(loginData);
    const { isCheckingAccess, hasSubscriptionAccess } = useSubscriptionAccess();
    const filterContainerRef = useRef<HTMLDivElement>(null);

    const [data, setData] = useState<MindMapItem[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [classOptions, setClassOptions] = useState<any[]>([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [noteModalVisible, setNoteModalVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState<MindMapItem | null>(null);
    // const [bookmark, setBookmark] = useState<boolean>(false);
    const [editNote, setEditNote] = useState<boolean>(false);
    const navigate = useNavigate();

    const location = useLocation();

    // Snapshot location.state ONCE into a ref so it is stable.
    // If we read from location.state directly, calling navigate(..., {state:null})
    // causes locationState to become null, which changes initialValues, which
    // causes formik (enableReinitialize:true) to wipe all the filter values we just set.
    const locationStateRef = useRef<any>(location.state);
    const locationState = locationStateRef.current;

    const initialBoard = locationState?.boardId
        ? { Id: locationState.boardId, Name: locationState.boardName }
        : coursePreferences?.boardDetails?.[0] || null;
    const initialClass = locationState?.classId
        ? { Id: locationState.classId, Name: locationState.className }
        : coursePreferences?.classDetails?.[0] || null;

    const initialSubject = locationState?.subjectList && Array.isArray(locationState.subjectList) && locationState.subjectList.length > 0
        ? locationState.subjectList
        : (locationState?.subjectId ? [{ Id: locationState.subjectId, Name: locationState.subjectName }] : []);

    const initialChapter = locationState?.chapterList && Array.isArray(locationState.chapterList) && locationState.chapterList.length > 0
        ? locationState.chapterList
        : (locationState?.chapterId ? [{ Id: locationState.chapterId, Name: locationState.chapterName }] : []);

    const initialTopic = locationState?.topicList && Array.isArray(locationState.topicList) && locationState.topicList.length > 0
        ? locationState.topicList
        : (locationState?.topicId ? [{ Id: locationState.topicId, Name: locationState.topicName }] : []);

    const [loadingFileKey, setLoadingFileKey] = useState<string | null>(null);

    const noteFormik = useFormik({
        enableReinitialize: true,
        initialValues: { note: selectedItem?.Note || '' },
        onSubmit: async (values, { resetForm }) => {
            console.log('Note submitted:', values.note);
            console.log('For item:', selectedItem);
            try {
                const response = await postNoteAndBookmark({ MindMapId: selectedItem?.id, Note: values.note });
                if (response && response.ResponseType === "SUCCESS") {
                    editNote ? toast.success("Note updated successfully!") : toast.success("Note added successfully!");
                    fetchMindMapList()
                }
                if (editNote) {
                    setEditNote(false);
                }

            } catch (error) {
                console.log("error");
                editNote ? toast.error("Unable to update the note") : toast.success("Unable to add note");

            }
            resetForm();
            setNoteModalVisible(false);
        },
    });

    const [localFilters, setLocalFilters] = useState<any>({
        [FILTER_LIST.LANGUAGE]: [],
        [FILTER_LIST.SUBJECT]: [],
        [FILTER_LIST.CHAPTER]: [],
        [FILTER_LIST.TOPIC]: [],
    });

    const { values, setFieldValue, setValues } = useFormik({
        initialValues: {
            [FILTER_KEYS.BOARD]: initialBoard,
            [FILTER_KEYS.CLASS]: initialClass,
            [FILTER_KEYS.LANGUAGE]: loginData?.LanguageId && loginData?.LanguageName ? { Id: loginData.LanguageId, Name: loginData.LanguageName } : null,
            [FILTER_KEYS.SUBJECT]: initialSubject,
            [FILTER_KEYS.CHAPTER]: initialChapter,
            [FILTER_KEYS.TOPIC]: initialTopic,
            returnFromResulPage: locationState?.returnFromResulPage || null,
        },
        enableReinitialize: true,
        onSubmit: () => { },
    });

    const returnFromResulPage = values?.returnFromResulPage ?? null;
    const selectedClassValue = values[FILTER_KEYS.CLASS] || classOptions[0] || coursePreferences?.classDetails?.[0] || null;

    const latestRequestIdRef = useRef<number>(0);
    const prevFiltersRef = useRef({
        lang: values[FILTER_KEYS.LANGUAGE],
        subject: values[FILTER_KEYS.SUBJECT],
        chapter: values[FILTER_KEYS.CHAPTER],
        topic: values[FILTER_KEYS.TOPIC],
        coursePreferences,
        classId: values[FILTER_KEYS.CLASS]?.Id,
    });

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        fetchLanguageList();
    }, []);

    useEffect(() => {
        const preferenceClass = coursePreferences?.classDetails?.[0];
        if (!preferenceClass?.Id) {
            setClassOptions([]);
            return;
        }

        const loadCombinedClassOptions = async () => {
            try {
                const response: APIResponse = await getCombinedClassList({ classId: preferenceClass.Id });
                if (response?.ResponseType === APIStatus.SUCCESS && Array.isArray(response.data)) {
                    const options = response.data.map((item: any) => ({
                        Id: Number(item?.id ?? item?.Id),
                        Name: item?.name ?? item?.Name,
                    }));
                    setClassOptions(options);

                    const preferredOption = options[0] || null;
                    if (preferredOption) {
                        setFieldValue(FILTER_KEYS.CLASS, preferredOption);
                    }
                    return;
                }
            } catch (error) {
                console.error("Error fetching combined class list:", error);
            }

            const fallbackOptions = (coursePreferences?.classDetails || []).map((item: any) => ({
                Id: Number(item?.Id),
                Name: item?.Name,
            }));
            setClassOptions(fallbackOptions);
            if (fallbackOptions[0]) {
                setFieldValue(FILTER_KEYS.CLASS, fallbackOptions[0]);
            }
        };

        loadCombinedClassOptions();
    }, [coursePreferences?.classDetails?.[0]?.Id]);

    // Fetch cascading dropdown data from the snapshotted location.state on mount.
    // This runs once after mount; the ref holds the original state so navigate
    // clearing location.state does not affect this logic.
    useEffect(() => {
        if (locationState) {
            const subList = initialSubject;
            const chapList = initialChapter;
            const board = initialBoard;
            const classDetail = initialClass;

            if (board?.Id && classDetail?.Id && subList.length > 0) {
                const subIds = subList.map((s: any) => s.Id).filter(Boolean);
                fetchChapterList(board.Id, classDetail.Id, subIds);
                if (chapList.length > 0) {
                    const chapIds = chapList.map((c: any) => c.Id).filter(Boolean);
                    fetchTopicList(board.Id, classDetail.Id, subIds, chapIds);
                }
            }
        }

        // Clear location.state from the history entry so a refresh starts clean.
        // Safe to do here because initialValues are derived from the stable ref,
        // not from live location.state, so formik won't reinitialise.
        if (location.state) {
            navigate(location.pathname, { replace: true, state: null });
        }
    }, []); // intentionally runs once on mount



    useEffect(() => {
        const boardId = values[FILTER_KEYS.BOARD]?.Id || coursePreferences?.boardDetails?.[0]?.Id;
        const classId = selectedClassValue?.Id;
        if (boardId && classId) {
            fetchSubjectList(boardId, classId);
        }
    }, [values[FILTER_KEYS.BOARD]?.Id, selectedClassValue?.Id, coursePreferences]);

    useEffect(() => {
        const boardId = values[FILTER_KEYS.BOARD]?.Id || coursePreferences?.boardDetails?.[0]?.Id;
        const classId = selectedClassValue?.Id;
        const subjects: any = values[FILTER_KEYS.SUBJECT];
        const subjectIds = Array.isArray(subjects)
            ? subjects.map((s: any) => s.Id).filter(Boolean)
            : (subjects?.Id ? [subjects.Id] : []);

        if (boardId && classId && subjectIds.length > 0) {
            fetchChapterList(boardId, classId, subjectIds);
        } else {
            setLocalFilters((prev: any) => ({ ...prev, [FILTER_LIST.CHAPTER]: [] }));
            if (values[FILTER_KEYS.CHAPTER]?.length > 0) {
                setFieldValue(FILTER_KEYS.CHAPTER, []);
            }
        }
    }, [values[FILTER_KEYS.SUBJECT], values[FILTER_KEYS.BOARD]?.Id, values[FILTER_KEYS.CLASS]?.Id]);

    useEffect(() => {
        const chapters: any = values[FILTER_KEYS.CHAPTER];
        if (chapters?.length > 0) {
            const chapterIds = chapters.map((c: any) => c.Id).filter(Boolean);
            const boardId = values[FILTER_KEYS.BOARD]?.Id || coursePreferences?.boardDetails?.[0]?.Id;
            const classId = selectedClassValue?.Id;
            const subjects: any = values[FILTER_KEYS.SUBJECT];
            const subjectIds = Array.isArray(subjects)
                ? subjects.map((s: any) => s.Id).filter(Boolean)
                : (subjects?.Id ? [subjects.Id] : undefined);
            fetchTopicList(boardId, classId, subjectIds, chapterIds);
        } else {
            setLocalFilters((prev: any) => ({ ...prev, [FILTER_LIST.TOPIC]: [] }));
            if (values[FILTER_KEYS.TOPIC]?.length > 0) {
                setFieldValue(FILTER_KEYS.TOPIC, []);
            }
        }
    }, [values[FILTER_KEYS.CHAPTER], values[FILTER_KEYS.BOARD]?.Id, values[FILTER_KEYS.CLASS]?.Id]);

    useEffect(() => {
        const filtersChanged =
            prevFiltersRef.current.lang !== values[FILTER_KEYS.LANGUAGE] ||
            prevFiltersRef.current.subject !== values[FILTER_KEYS.SUBJECT] ||
            prevFiltersRef.current.chapter !== values[FILTER_KEYS.CHAPTER] ||
            prevFiltersRef.current.topic !== values[FILTER_KEYS.TOPIC] ||
            prevFiltersRef.current.coursePreferences !== coursePreferences ||
            prevFiltersRef.current.classId !== values[FILTER_KEYS.CLASS]?.Id;

        prevFiltersRef.current = {
            lang: values[FILTER_KEYS.LANGUAGE],
            subject: values[FILTER_KEYS.SUBJECT],
            chapter: values[FILTER_KEYS.CHAPTER],
            topic: values[FILTER_KEYS.TOPIC],
            coursePreferences,
            classId: values[FILTER_KEYS.CLASS]?.Id,
        };

        if (filtersChanged && first !== 0) {
            setFirst(0);
            return;
        }

        fetchMindMapList();
    }, [
        first,
        rows,
        values[FILTER_KEYS.LANGUAGE],
        values[FILTER_KEYS.SUBJECT],
        values[FILTER_KEYS.CHAPTER],
        values[FILTER_KEYS.TOPIC],
        values[FILTER_KEYS.CLASS]?.Id,
        returnFromResulPage,
        coursePreferences,
    ]);

    const fetchLanguageList = async () => {
        try {
            const response: APIResponse = await getLanguageList();
            if (response.ResponseType === APIStatus.SUCCESS) {
                setLocalFilters((prev: any) => ({
                    ...prev,
                    [FILTER_LIST.LANGUAGE]: response.data || [],
                }));
            }
        } catch (e) {
            console.error("Error fetching language list:", e);
        }
    };

    const fetchSubjectList = async (boardId: number, classId: number) => {
        try {
            const response: APIResponse = await getSubjectList({ boardId, classId });
            if (response.ResponseType === APIStatus.SUCCESS) {
                setLocalFilters((prev: any) => ({
                    ...prev,
                    [FILTER_LIST.SUBJECT]: response.data || [],
                }));
            }
        } catch (e) {
            console.error("Error fetching subject list:", e);
        }
    };

    const fetchChapterList = async (boardId: number, classId: number, subjectIds: number[]) => {
        try {
            const response: APIResponse = await getChapterList({
                boardId,
                classId,
                subjectId: subjectIds.join(","),
            });
            if (response.ResponseType === APIStatus.SUCCESS) {
                setLocalFilters((prev: any) => ({
                    ...prev,
                    [FILTER_LIST.CHAPTER]: response.data || [],
                }));
            }
        } catch (e) {
            console.error("Error fetching chapter list:", e);
        }
    };

    const fetchTopicList = async (boardId: number | undefined, classId: number | undefined, subjectIds: number[] | undefined, chapterIds: number[]) => {
        try {
            const params: any = {
                chapterId: chapterIds.join(","),
            };
            if (boardId) params.boardId = boardId;
            if (classId) params.classId = classId;
            if (subjectIds && subjectIds.length > 0) params.subjectId = subjectIds.join(",");
            const response: APIResponse = await getTopicList(params);
            if (response.ResponseType === APIStatus.SUCCESS) {
                setLocalFilters((prev: any) => ({
                    ...prev,
                    [FILTER_LIST.TOPIC]: response.data || [],
                }));
            }
        } catch (e) {
            console.error("Error fetching topic list:", e);
        }
    };

    const fetchMindMapList = async () => {
        const requestId = ++latestRequestIdRef.current;
        setIsLoading(true);
        try {
            const params: any = {
                page: (first / rows) + 1,
                limit: rows,
            };

            if (!!returnFromResulPage) {
                params.returnFromResulPage = returnFromResulPage
            }

            //no need to send boardId as it is not required in backend for mindmap api for now, so commented it out. If required in future, uncomment it and use it.
            // const boardId = values[FILTER_KEYS.BOARD]?.Id || coursePreferences?.boardDetails?.[0]?.Id;
            const classId = selectedClassValue?.Id;
            const prefSubjectIds = coursePreferences?.subjectDetails?.length > 0 ? coursePreferences?.subjectDetails?.map((s: any) => s.Id) : [];

            //no need to send boardId as it is not required in backend for mindmap api for now, so commented it out. If required in future, uncomment it and use it.
            // if (boardId) params.boardId = boardId;
            if (classId) params.classId = classId;

            const lang = values[FILTER_KEYS.LANGUAGE];
            if (lang?.Id) params.langId = lang.Id;

            const subjects: any[] = values[FILTER_KEYS.SUBJECT];
            if (Array.isArray(subjects) && subjects.length > 0) {
                params.subjectId = subjects.map((s: any) => s.Id).filter(Boolean).join(",");
            } else if (subjects && !Array.isArray(subjects) && (subjects as any).Id) {
                params.subjectId = (subjects as any).Id;
            } else if (prefSubjectIds.length > 0) {
                params.subjectId = prefSubjectIds.join(",");
            }

            const chapters: any[] = values[FILTER_KEYS.CHAPTER];
            if (chapters?.length > 0)
                params.chapterId = chapters.map((c: any) => c.Id).filter(Boolean).join(",");

            const topics: any[] = values[FILTER_KEYS.TOPIC];
            if (topics?.length > 0)
                params.topicId = topics.map((t: any) => t.Id).filter(Boolean).join(",");

            const response: any = await getMindMapList(params);

            // Stale response check: discard if a newer request has been triggered
            if (requestId !== latestRequestIdRef.current) {
                return;
            }

            if (response?.success && response?.data?.result) {
                setData(response.data.result);
                setTotalRecords(response.data.total_record || response.data.result.length);
            } else {
                setData([]);
                setTotalRecords(0);
            }
        } catch (error) {
            if (requestId !== latestRequestIdRef.current) {
                return;
            }
            console.error("Error fetching mind map list:", error);
            setData([]);
            setTotalRecords(0);
        } finally {
            if (requestId === latestRequestIdRef.current) {
                setIsLoading(false);
            }
        }
    };

    const handleFilterChange = (field: string, value: any) => {
        if (first !== 0) {
            setFirst(0);
        }

        if (field === FILTER_KEYS.CLASS) {
            const boardId = values[FILTER_KEYS.BOARD]?.Id || coursePreferences?.boardDetails?.[0]?.Id;

            setLocalFilters((prev: any) => ({
                ...prev,
                [FILTER_LIST.SUBJECT]: [],
                [FILTER_LIST.CHAPTER]: [],
                [FILTER_LIST.TOPIC]: [],
            }));
            setValues((prev: any) => ({
                ...prev,
                [FILTER_KEYS.CLASS]: value,
                [FILTER_KEYS.SUBJECT]: [],
                [FILTER_KEYS.CHAPTER]: [],
                [FILTER_KEYS.TOPIC]: [],
            }));

            if (boardId && value?.Id) {
                fetchSubjectList(boardId, value.Id);
            }
            return;
        }

        // Clear dependent downstream fields atomically
        if (field === FILTER_KEYS.SUBJECT) {
            setLocalFilters((prev: any) => ({
                ...prev,
                [FILTER_LIST.CHAPTER]: [],
                [FILTER_LIST.TOPIC]: [],
            }));
            setValues((prev: any) => ({
                ...prev,
                [FILTER_KEYS.SUBJECT]: value,
                [FILTER_KEYS.CHAPTER]: [],
                [FILTER_KEYS.TOPIC]: [],
            }));
        } else if (field === FILTER_KEYS.CHAPTER) {
            setLocalFilters((prev: any) => ({ ...prev, [FILTER_LIST.TOPIC]: [] }));
            setValues((prev: any) => ({
                ...prev,
                [FILTER_KEYS.CHAPTER]: value,
                [FILTER_KEYS.TOPIC]: [],
            }));
        } else {
            setFieldValue(field, value);
        }
    };

    const onClickClearFilter = () => {
        if (first !== 0) {
            setFirst(0);
        }

        const board = coursePreferences?.boardDetails?.[0] || null;
        const classDetail = classOptions[0] || coursePreferences?.classDetails?.[0] || null;

        const nextValues = {
            [FILTER_KEYS.BOARD]: board,
            [FILTER_KEYS.CLASS]: classDetail,
            [FILTER_KEYS.LANGUAGE]: loginData?.LanguageId && loginData?.LanguageName ? { Id: loginData.LanguageId, Name: loginData.LanguageName } : null,
            [FILTER_KEYS.SUBJECT]: [],
            [FILTER_KEYS.CHAPTER]: [],
            [FILTER_KEYS.TOPIC]: [],
            returnFromResulPage: null,
        };

        setValues(nextValues);

        // Keep the available subject list intact; only reset the active selections.
        setLocalFilters((prev: any) => ({
            ...prev,
            [FILTER_LIST.CHAPTER]: [],
            [FILTER_LIST.TOPIC]: [],
        }));

        if (board?.Id && classDetail?.Id) {
            fetchSubjectList(board.Id, classDetail.Id);
        }
    };

    const getMultiSelectLabel = (label: string, selectedItems: any[]) => {
        if (!selectedItems || selectedItems.length === 0) return label;
        const firstName = selectedItems[0]?.Name || "";
        const displayName = firstName.length > 4 ? firstName.substring(0, 4) + "..." : firstName;
        let result = `${label}: ${displayName}`;
        if (selectedItems.length > 1) result += `, +${selectedItems.length - 1}`;
        return result;
    };


    const onPageChange = (event: any) => {
        setFirst(event.first);
        setRows(event.rows);
    };
    const paginatedData = data.length > rows ? data.slice(first, first + rows) : data;

    const handleDownload = async (url: string | null, filename?: string) => {
        if (!url) return;
        try {

            //as cors not allowed in s3 bucket so commented this

            // const response = await fetch(url);
            // const blob = await response.blob();
            // const objectUrl = window.URL.createObjectURL(blob);
            // const anchor = document.createElement("a");
            // anchor.href = objectUrl;
            // const name = filename || url.split("/").pop() || "download.pdf";
            // anchor.download = name;
            // document.body.appendChild(anchor);
            // anchor.click();
            // document.body.removeChild(anchor);
            // window.URL.revokeObjectURL(objectUrl);

            //as cors not allowed is s3 bucket so need this line
            window.open(url, "_blank", "noopener,noreferrer");
        } catch (error) {
            // console.error("Download failed:", error);
            window.open(url, "_blank", "noopener,noreferrer");
        }
    };

    const SkeletonTable = () => (
        <table className="table table-auto tw-w-full">
            <thead>
                <tr>
                    {["Board", "Class", "Subject", "Chapter", "Topic", "Language", "Actions"].map((h) => (
                        <th key={h}>{h}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {[...Array(5)].map((_, i) => (
                    <tr key={i}>
                        {[...Array(7)].map((_, j) => (
                            <td key={j}>
                                <Skeleton height="1.5rem" />
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
    const handleBookmark = async (item: any) => {
        try {
            const response = await postNoteAndBookmark({ MindMapId: item?.id, IsBookMarked: item?.IsBookMarked === 0 ? 1 : (item?.IsBookMarked === 1 ? 0 : 1) });
            if (response && response.ResponseType === "SUCCESS") {
                (item?.IsBookMarked === 0 || item?.IsBookMarked === null) ? toast.success("Item is bookmarked", { duration: 1000 }) : toast.success("Bookmark removed successfully", { duration: 1000 });
                fetchMindMapList();
            }
        } catch (error) {
            toast.error("Unable to bookmark the item", { duration: 1000 })
            console.log(error);

        }
    }


    const fetchFile = async (fileName: string | null, type: 'revision' | 'mindmap' | 'formula' | 'lastminute', itemId?: number) => {
        const fileKey = itemId ? `${itemId}-${type}` : type;
        setLoadingFileKey(fileKey);

        try {
            const response = await getMindMapFile({ file_name: fileName });
            if (response.ResponseType === 'SUCCESS' && response.data) {
                const signedUrl = response.data?.sign_url;
                if (signedUrl) {
                    window.open(signedUrl, "_blank", "noopener,noreferrer");
                } else {
                    toast.error('No file available');
                }
            } else {
                toast.error('Something went wrong');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingFileKey((currentKey) => currentKey === fileKey ? null : currentKey);
        }
    };

    const isAnyFileLoading = loadingFileKey !== null;

    return (
        <div className="mind-map-container">
            <div className="mind-map-header">
                <h1 className="mind-map-title">Revision Hub</h1>
                <p className="mind-map-subtitle">
                    Download chapter-wise notes
                </p>
            </div>

            {!isCheckingAccess && hasSubscriptionAccess && (
                <section className="filter-section-mindmap pb-6">
                    <div className="filter-head">
                        <div className="text-sm">Choose a Filter to Refine Results</div>
                    </div>
                    <div className="filter-main-container">
                        <div className="filter-dropdown-container" ref={filterContainerRef}>
                            {/* Board — disabled, from course preference */}
                            <Dropdown
                                value={values[FILTER_KEYS.BOARD]}
                                options={coursePreferences?.boardDetails || []}
                                optionLabel="Name"
                                dataKey="Id"
                                placeholder={coursePreferences?.boardDetails?.[0]?.Name || "Board"}
                                className="filter-dropdown"
                                disabled
                                appendTo="self"
                            />

                            {/* Class — from combined class API for the selected course preference */}
                            <Dropdown
                                value={values[FILTER_KEYS.CLASS]}
                                name={FILTER_KEYS.CLASS}
                                onChange={(e) => handleFilterChange(FILTER_KEYS.CLASS, e.value)}
                                options={classOptions.length > 0 ? classOptions : coursePreferences?.classDetails || []}
                                optionLabel="Name"
                                dataKey="Id"
                                placeholder={classOptions[0]?.Name || coursePreferences?.classDetails?.[0]?.Name || "Class"}
                                className="filter-dropdown"
                                appendTo="self"
                            />

                            {/* Language — disabled, from course preference (user's login language) */}
                            <Dropdown
                                value={values[FILTER_KEYS.LANGUAGE]}
                                name={FILTER_KEYS.LANGUAGE}
                                onChange={(e) => handleFilterChange(FILTER_KEYS.LANGUAGE, e.value)}
                                options={localFilters[FILTER_LIST.LANGUAGE]}
                                optionLabel="Name"
                                dataKey="Id"
                                placeholder={loginData?.LanguageName || "Language"}
                                className="filter-dropdown"
                                disabled
                                appendTo="self"
                            />

                            {/* Subject */}
                            <MultiSelect
                                value={values[FILTER_KEYS.SUBJECT]}
                                name={FILTER_KEYS.SUBJECT}
                                onChange={(e) => handleFilterChange(FILTER_KEYS.SUBJECT, e.value)}
                                options={
                                    localFilters[FILTER_LIST.SUBJECT]?.length > 0
                                        ? localFilters[FILTER_LIST.SUBJECT]
                                        : [{ Id: "empty", Name: "No subjects found" }]
                                }
                                optionLabel="Name"
                                dataKey="Id"
                                optionDisabled={(o) => o.Id === "empty"}
                                placeholder="Subject"
                                className="filter-dropdown"
                                maxSelectedLabels={0}
                                selectedItemsLabel={getMultiSelectLabel("Subject", values[FILTER_KEYS.SUBJECT])}
                                filter
                                appendTo="self"
                                emptyFilterMessage="No subjects found"
                            />

                            {/* Chapter */}
                            <MultiSelect
                                value={values[FILTER_KEYS.CHAPTER]}
                                name={FILTER_KEYS.CHAPTER}
                                onChange={(e) => handleFilterChange(FILTER_KEYS.CHAPTER, e.value)}
                                options={
                                    localFilters[FILTER_LIST.CHAPTER]?.length > 0
                                        ? localFilters[FILTER_LIST.CHAPTER]
                                        : [{ Id: "empty", Name: "No chapters found" }]
                                }
                                optionLabel="Name"
                                dataKey="Id"
                                optionDisabled={(o) => o.Id === "empty"}
                                placeholder="Chapter"
                                className="filter-dropdown"
                                disabled={!values[FILTER_KEYS.SUBJECT] || (values[FILTER_KEYS.SUBJECT] as any[]).length === 0}
                                maxSelectedLabels={0}
                                selectedItemsLabel={getMultiSelectLabel("Chapter", values[FILTER_KEYS.CHAPTER])}
                                filter
                                appendTo="self"
                                emptyFilterMessage="No chapters found"
                            />

                            {/* Topic */}
                            {/* <MultiSelect
                                value={values[FILTER_KEYS.TOPIC]}
                                name={FILTER_KEYS.TOPIC}
                                onChange={(e) => handleFilterChange(FILTER_KEYS.TOPIC, e.value)}
                                options={
                                    localFilters[FILTER_LIST.TOPIC]?.length > 0
                                        ? localFilters[FILTER_LIST.TOPIC]
                                        : [{ Id: "empty", Name: "No topics found" }]
                                }
                                optionLabel="Name"
                                dataKey="Id"
                                optionDisabled={(o) => o.Id === "empty"}
                                placeholder="Topic"
                                className="filter-dropdown"
                                disabled={!values[FILTER_KEYS.CHAPTER] || (values[FILTER_KEYS.CHAPTER] as any[]).length === 0}
                                maxSelectedLabels={0}
                                selectedItemsLabel={getMultiSelectLabel("Topic", values[FILTER_KEYS.TOPIC])}
                                filter
                                appendTo="self"
                                emptyFilterMessage="No topics found"
                            /> */}

                            {/* Clear Filter */}
                            <a
                                className="ia-btn ia-btn-outline-primary tw-text-lg py-1 px-2"
                                onClick={onClickClearFilter}
                                style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                            >
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_mm_clear)">
                                        <path d="M3.64216 3.45501C4.85187 2.40679 6.39949 1.83078 8.00016 1.83301C11.6822 1.83301 14.6668 4.81768 14.6668 8.49968C14.6668 9.92368 14.2202 11.2437 13.4602 12.3263L11.3335 8.49968H13.3335C13.3336 7.4541 13.0263 6.43155 12.4499 5.55919C11.8735 4.68682 11.0535 4.00312 10.0916 3.5931C9.12978 3.18307 8.06864 3.06482 7.04013 3.25303C6.01163 3.44124 5.06113 3.92761 4.30683 4.65168L3.64216 3.45501ZM12.3582 13.5443C11.1485 14.5926 9.60084 15.1686 8.00016 15.1663C4.31816 15.1663 1.3335 12.1817 1.3335 8.49968C1.3335 7.07568 1.78016 5.75568 2.54016 4.67301L4.66683 8.49968H2.66683C2.66674 9.54527 2.974 10.5678 3.55039 11.4402C4.12678 12.3125 4.94687 12.9962 5.90871 13.4063C6.87054 13.8163 7.93169 13.9345 8.96019 13.7463C9.9887 13.5581 10.9392 13.0717 11.6935 12.3477L12.3582 13.5443Z" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_mm_clear">
                                            <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                Clear Filter
                            </a>
                        </div>
                    </div>
                </section>
            )}
            <Card className="mind-map-card">
                {/* ── Filter Bar ── */}


                {/* ── Table ── */}
                <div className="mind-map-content">
                    <div className="mind-map-table-content">
                        <div className="table-responsive">
                            {isCheckingAccess ? (
                                <SkeletonTable />
                            ) : !hasSubscriptionAccess ? (
                                <div className="tw-p-10 tw-text-center tw-text-lg tw-font-medium tw-text-gray-600">
                                    {isInstitute
                                        ? <div>You do not have permission to review the <span className="tw-font-bold tw-text-purple-600">Revision Hub</span> page. Please contact your institute's administrator</div>
                                        : <div>You do not have permission to review the <span className="tw-font-bold tw-text-purple-600">Revision Hub</span> page. Please upgrade your subscription</div>
                                    }
                                </div>
                            ) : isLoading ? (
                                <SkeletonTable />
                            ) : paginatedData && paginatedData.length > 0 ? (
                                <table className="table table-auto">
                                    <thead>
                                        <tr>
                                            {/* <th className="tw-text-left">Board</th>
                                            <th className="tw-text-left">Class</th> */}
                                            <th className="tw-text-left text-sm">Subject</th>
                                            <th className="tw-text-left text-sm">Chapter</th>
                                            {/* <th className="tw-text-left text-sm">Topic</th> */}
                                            <th className="tw-text-center text-sm">Core Note</th>
                                            <th className="tw-text-center text-sm">Chapter Snapshot</th>
                                            <th className=" tw-text-center text-sm">Formula Bank</th>
                                            <th className="tw-text-center text-sm">Rapid Recap + PYQ</th>
                                            <th className="tw-text-center text-sm" >
                                                Actions
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paginatedData.map((item, index) => (
                                            <tr key={`${item.id}-${item.LangId}-${index}`}>
                                                {/* <td>{item.boardName}</td>
                                                <td>{item.className}</td> */}
                                                <td>{item.subjectName}</td>
                                                <td>{item.chapterName || "-"}</td>
                                                {/* <td>{item.topicName || "-"}</td> */}
                                                <td className="tw-text-center" style={{ width: "13%" }}>
                                                    <button
                                                        className="download-btn revision-btn"
                                                        disabled={!item.revisionnotedocUrl || isAnyFileLoading}
                                                        // onClick={() =>
                                                        //     handleDownload(
                                                        //         item.revisionnotedocUrl,
                                                        //         `${item.chapterName}-${item.topicName}-revision-note.pdf`
                                                        //     )
                                                        // }
                                                        onClick={() => {
                                                            if (isAnyFileLoading || !item.revisionnotedocUrl) return;
                                                            fetchFile(item.revisionnotedocUrl, 'revision', item.id);
                                                        }}
                                                        data-tooltip-id="mindmap-action-tip"
                                                        data-tooltip-content={
                                                            item.revisionnotedocUrl
                                                                ? "Open Core Note"
                                                                : "Core Note not available"
                                                        }
                                                    >
                                                        {
                                                            loadingFileKey === `${item.id}-revision`
                                                                ? <ProgressSpinner className="white-spinner" style={{ width: "12px", height: "12px", color: "white" }} strokeWidth="8" animationDuration="1s" />
                                                                : <i className="pi pi-external-link" style={{ fontSize: "12px" }} />
                                                        }


                                                    </button>
                                                </td>
                                                <td className="tw-text-center" style={{ width: "13%" }}>
                                                    <button
                                                        className="download-btn mindmap-btn"
                                                        disabled={!item.mindmapdocUrl || isAnyFileLoading}
                                                        // onClick={() =>
                                                        //     handleDownload(
                                                        //         item.mindmapdocUrl,
                                                        //         `${item.chapterName}-${item.topicName}-mind-map.pdf`
                                                        //     )
                                                        // }
                                                        onClick={() => {
                                                            if (isAnyFileLoading || !item.mindmapdocUrl) return;
                                                            fetchFile(item.mindmapdocUrl, 'mindmap', item.id);
                                                        }}
                                                        data-tooltip-id="mindmap-action-tip"
                                                        data-tooltip-content={
                                                            item.mindmapdocUrl
                                                                ? "Open Chapter Snapshot"
                                                                : "Chapter Snapshot not available"
                                                        }
                                                    >
                                                        {
                                                            loadingFileKey === `${item.id}-mindmap`
                                                                ? <ProgressSpinner className="white-spinner" style={{ width: "12px", height: "12px", color: "white" }} strokeWidth="8" animationDuration="1s" />
                                                                : <i className="pi pi-external-link" style={{ fontSize: "12px" }} />
                                                        }

                                                    </button>
                                                </td>
                                                <td className="tw-text-center" style={{ width: "13%" }}>
                                                    <button
                                                        className="download-btn formulaDoc-btn"
                                                        disabled={!item.formulaDocFileUrl || isAnyFileLoading}
                                                        // onClick={() => {
                                                        //     if (isAnyFileLoading || !item.formulaDocFileUrl) return;
                                                        //     handleDownload(
                                                        //         item.formulaDocFileUrl,
                                                        //         `${item.chapterName}-${item.topicName}-formula-doc.pdf`
                                                        //     );
                                                        // }}
                                                        onClick={() => {
                                                            if (isAnyFileLoading || !item.formulaDocFileUrl) return;
                                                            fetchFile(item.formulaDocFileUrl, 'formula', item.id);
                                                        }}
                                                        data-tooltip-id="mindmap-action-tip"
                                                        data-tooltip-content={
                                                            item.formulaDocFileUrl
                                                                ? "Open Formula Bank"
                                                                : "Formula Bank not available"
                                                        }
                                                    >
                                                        {
                                                            loadingFileKey === `${item.id}-formula`
                                                                ? <ProgressSpinner className="white-spinner" style={{ width: "12px", height: "12px", color: "white" }} strokeWidth="8" animationDuration="1s" />
                                                                : <i className="pi pi-external-link" style={{ fontSize: "12px" }} />
                                                        }


                                                    </button>
                                                </td>
                                                <td className="tw-text-center" style={{ width: "13%" }}>
                                                    <button
                                                        className="download-btn lastMinute-btn"
                                                        disabled={!item.lastMinuteDocFileUrl || isAnyFileLoading}
                                                        // onClick={() => {
                                                        //     if (isAnyFileLoading || !item.lastMinuteDocFileUrl) return;
                                                        //     handleDownload(
                                                        //         item.lastMinuteDocFileUrl,
                                                        //         `${item.chapterName}-${item.topicName}-last-minute-doc.pdf`
                                                        //     );
                                                        // }}
                                                        onClick={() => {
                                                            if (isAnyFileLoading || !item.lastMinuteDocFileUrl) return;
                                                            fetchFile(item.lastMinuteDocFileUrl, 'lastminute', item.id);
                                                        }}
                                                        data-tooltip-id="mindmap-action-tip"
                                                        data-tooltip-content={
                                                            item.lastMinuteDocFileUrl
                                                                ? "Open Rapid Recap + PYQ"
                                                                : "Rapid Recap + PYQ not available"
                                                        }
                                                    >

                                                        {
                                                            loadingFileKey === `${item.id}-lastminute`
                                                                ? <ProgressSpinner className="white-spinner" style={{ width: "12px", height: "12px", color: "white" }} strokeWidth="8" animationDuration="1s" />
                                                                : <i className="pi pi-external-link" style={{ fontSize: "12px" }} />
                                                        }
                                                    </button>
                                                </td>
                                                <td className="tw-text-center">
                                                    <div className="tw-flex tw-items-center tw-justify-center tw-gap-2">



                                                        <button
                                                            // className="download-btn addNote-btn"
                                                            onClick={() => {
                                                                setSelectedItem(item);
                                                                setNoteModalVisible(true);
                                                            }}
                                                            data-tooltip-id="mindmap-action-tip"
                                                            data-tooltip-content={item?.Note ? "View/Edit Note" : "Add Note"}
                                                        >
                                                            {
                                                                item?.Note ? <i className="pi pi-eye" style={{ fontSize: "18px" }} /> : <i className="pi pi-file-edit" style={{ fontSize: "18px" }} />
                                                            }

                                                        </button>

                                                        <div onClick={() => { handleBookmark(item) }} data-tooltip-id="mindmap-action-tip"
                                                            data-tooltip-content={item?.IsBookMarked === 1 ? "Bookmarked" : "Bookmark"}>
                                                            {
                                                                item?.IsBookMarked === 1 ? <i className="pi pi-bookmark-fill" style={{ fontSize: "18px", color: "black", cursor: "pointer" }} /> : <i className="pi pi-bookmark" style={{ fontSize: "18px", cursor: "pointer" }} />
                                                            }


                                                        </div>
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                const board = coursePreferences?.boardDetails?.[0];
                                                                const classDetail = coursePreferences?.classDetails?.[0];
                                                                navigate(`${TestSereisRouteURL.TEST_SERIES}`, {
                                                                    state: {
                                                                        boardId: board?.Id,
                                                                        boardName: board?.Name,
                                                                        classId: classDetail?.Id,
                                                                        className: classDetail?.Name,
                                                                        subjectId: item.SubjectId,
                                                                        subjectName: item.subjectName,
                                                                        chapterId: item.ChapterId,
                                                                        chapterName: item.chapterName,
                                                                        topicId: item.TopicId,
                                                                        topicName: item.topicName,
                                                                    }
                                                                });
                                                            }}
                                                            data-tooltip-id="mindmap-action-tip"
                                                            data-tooltip-content="Go to Practice Test"
                                                            aria-label="Go to Practice Test"
                                                            style={{ background: "none", border: "none", padding: 0, cursor: "pointer", display: "inline-flex", alignItems: "center" }}
                                                        >
                                                            <i className="pi pi-arrow-circle-right" style={{ fontSize: "18px", cursor: "pointer" }} />
                                                        </button>


                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : (
                                <div className="no-data-section">
                                    <i className="pi pi-book" style={{ fontSize: "4rem", color: "#d1d5db" }} />
                                    <div className="no-data-message">
                                        No chapter snapshots or core notes available for the selected filters.
                                    </div>
                                </div>
                            )}
                        </div>

                        {!isCheckingAccess && hasSubscriptionAccess && !isLoading && totalRecords > 0 && (
                            <Paginator
                                first={first}
                                rows={rows}
                                totalRecords={totalRecords}
                                rowsPerPageOptions={[10, 20, 30]}
                                onPageChange={onPageChange}
                                className="custom-paginator"
                                pageLinkSize={isMobile ? 2 : 5}
                            />
                        )}
                    </div>
                </div>
            </Card >

            <Tooltip id="mindmap-action-tip" style={{
                fontSize: '10px',
                padding: '4px 6px'
            }} />

            <Dialog
                visible={noteModalVisible}
                onHide={() => {
                    setNoteModalVisible(false);
                    noteFormik.resetForm();
                }}
                header={selectedItem?.Note ? (editNote ? "Edit Note" : "Your Note") : "Add Note"}
                style={{ width: '500px' }}
                modal
                draggable={false}
                resizable={false}
            >
                <form onSubmit={noteFormik.handleSubmit}>
                    <div className="tw-mb-4">
                        <textarea
                            name="note"
                            rows={6}
                            className="tw-w-full tw-p-3 tw-border tw-border-gray-300 tw-rounded focus:tw-outline-none focus:tw-ring-0 focus:tw-shadow-none"
                            placeholder="Enter your note here..."
                            value={noteFormik.values.note}
                            onChange={noteFormik.handleChange}
                            style={{ resize: "none" }}
                            disabled={Boolean(selectedItem?.Note) && !editNote}
                        />
                    </div>
                    {
                        (selectedItem?.Note && !editNote) ?
                            <div className="tw-flex tw-justify-end tw-gap-2">
                                <button
                                    type="button"
                                    className="ia-btn ia-btn-outline-primary py-2 px-4"
                                    onClick={() => {
                                        setEditNote(true);
                                    }}
                                >
                                    Edit Note
                                </button>
                            </div>
                            :
                            <div className="tw-flex tw-justify-end tw-gap-2">
                                <button
                                    type="button"
                                    className="ia-btn ia-btn-outline-primary py-2 px-4"
                                    onClick={() => {
                                        if (editNote) {
                                            setEditNote(false);
                                        } else {
                                            setNoteModalVisible(false);
                                            noteFormik.resetForm();
                                        }

                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="ia-btn ia-btn-primary py-2 px-4"
                                >
                                    Save Note
                                </button>
                            </div>
                    }

                </form>
            </Dialog>
        </div >
    );
};
